import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import * as actions from '../redux/actions';
import { Loading } from '../components/Loading';
import { NotFound } from '../components/Error';
import accessRight from '../utils/functions/accessRight';

import { SaleBuy, Sale, Buy, Summary, EditOrderGold } from '../views/Gold';
import DetailOrderGold from '../views/Gold/DetailOrderGold';
import SumPaymentGold from '../views/Gold/SumPaymentGold';
import DetailPaymentAnother from '../views/Gold/DetailPaymentAnother';

export function Gold() {
  const module = 'GOLD';
  const prefix = '/gold';
  const name = 'ซื้อ - ขาย';

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    dispatch(actions.meGet());
    dispatch(actions.informationAll());

    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  if (accessRight(me, module)) {
    return (
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="relative lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/gold`} />
              {/* <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} /> */}
              <Route exact path={`${prefix}/gold`}>
                <SaleBuy title=" การซื้อ-ขายทอง" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/addProduct-sale`}>
                <Sale title="ขายสินค้า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/addProduct-buy`}>
                <Buy title="ซื้อสินค้า" subtitle={name} />
              </Route>
              {/* <Route exact path={`${prefix}/history/detail/cash/:id`}>
                <DetailOrderGoldCash
                  title="รายละเอียดการซื้อ-ขายเงินสด"
                  subtitle={name}
                />
              </Route> */}
              <Route exact path={`${prefix}/summary/detail/:id`}>
                <DetailOrderGold
                  title="รายละเอียดการซื้อ-ขาย"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/edit-order-gold/:id`}>
                <EditOrderGold title="แก้ไขข้อมูลการซื้อ-ขาย" subtitle={name} />
              </Route>
              {/* <Route exact path={`${prefix}/report/detail/:id`}>
                <DetailReportGold
                  title="รายละเอียดรายงานการซื้อ-ขาย"
                  subtitle={name}
                />
              </Route> */}
              {/* <Route exact path={`${prefix}/history`}>
                <HistoryBuy title="สรุปรายการเงินสด" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/reportgold`}>
                <ReportGold title="รายงานการซื้อ-ขาย" subtitle={name} />
              </Route> */}
              <Route exact path={`${prefix}/summary`}>
                <Summary title="สรุปรายการซื้อ-ขาย ทอง" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/history-payment`}>
                <SumPaymentGold title="บัญชีรายวัน" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/detail/payment-other`}>
                <DetailPaymentAnother
                  title="ประวัติธุรกรรมการเงิน"
                  subtitle={name}
                />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }
  return <></>;
}

export default Gold;
